import React from 'react';
import { Table } from 'snacks-design-system';
interface componentProps {
  data: any[];
  caption?: React.ReactNode;
  modBorder?: boolean;
  modAuto?: boolean;
  dataStrack?: string;
  qaSelector?: string;
}

const PIETable = (props: componentProps) => {
  return <Table {...props} />;
};

export default PIETable;
